export class permitsUserFetch {
    public canEdit: boolean = false;
    public canCreate: boolean = false;
    public canDelete: boolean = false;
    public canActive: boolean = false;
    public other: boolean = false;
    public canView: boolean = false;
}